import { parseISO } from 'date-fns';
import { format } from 'date-fns';

/**
 * Parses various date formats into a Date object.
 * @param input Can be any of the types we expect to see for a date on the backend.
 * @returns A JavaScript Date object, or null if the date cannot be parsed.
 */
export const makeDateConsistent = (
    input: Date | string | number | undefined | null
): Date | null => {
    const date = convertDate(input);
    if (date === null) return null;
    if (isNaN(date.getTime())) return null;
    return date;
};

const convertDate = (
    input: Date | string | number | undefined | null
): Date | null => {
    if (input === null) return null;
    switch (typeof input) {
        case 'string':
            return parseISO(input);
        case 'number':
            return new Date(input);
        case 'object':
            if (input instanceof Date) return input as Date;
            return null;
        default:
            return null;
    }
};

/** Get today's date in YYYYMMDD (e.g., 11/16/2022 becomes 20221116)format used in device tank level predictions. */
export function getTodayDd(): string {
    const today = new Date();
    const todayDay =
        today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
    return `${today.getFullYear()}${today.getMonth() + 1}${todayDay}`;
}

/** Returns a string formatting the inputted timestamp like 1/16/23, 5:00 PM or whatever the locale equivalent is.  */
export function getDateWithTime(timestamp: number): string {
    return new Date(timestamp).toLocaleString([], {
        dateStyle: 'short',
        timeStyle: 'short',
    });
}

/**
 * Get MM-DD-YYYY date from a timestamp.
 * @param {number} timestamp Timestamp value (i.e., like you'd get from `new Date().getTime().`)
 * @returns A string representing the MM-DD-YYYY value of the timestamp.
 */
export function getMonthDayYear(timestamp: number): string {
    return format(new Date(Math.round(timestamp)), 'MM/dd/yyyy');
}
